// Studyo Today Backend
// Package studyo.today.google_calendar.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/google_calendar/v1/resources/sync_blocker.proto (package studyo.today.google_calendar.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/google_calendar/v1/resources/sync_blocker.proto.
 */
export const file_studyo_today_google_calendar_v1_resources_sync_blocker = /*@__PURE__*/
  fileDesc("CjxzdHVkeW8vdG9kYXkvZ29vZ2xlX2NhbGVuZGFyL3YxL3Jlc291cmNlcy9zeW5jX2Jsb2NrZXIucHJvdG8SKXN0dWR5by50b2RheS5nb29nbGVfY2FsZW5kYXIudjEucmVzb3VyY2VzKskBCgtTeW5jQmxvY2tlchIcChhTWU5DX0JMT0NLRVJfVU5TUEVDSUZJRUQQABIfChtTWU5DX0JMT0NLRVJfSU5URVJOQUxfRVJST1IQARIpCiVTWU5DX0JMT0NLRVJfTk9fR09PR0xFX09GRkxJTkVfQUNDRVNTEAISLQopU1lOQ19CTE9DS0VSX01JU1NJTkdfR09PR0xFX0FDQ0VTU19TQ09QRVMQAxIhCh1TWU5DX0JMT0NLRVJfVU5FWFBFQ1RFRF9FUlJPUhAEQjCqAi1TdHVkeW8uVG9kYXkuR29vZ2xlQ2FsZW5kYXIuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the enum studyo.today.google_calendar.v1.resources.SyncBlocker.
 */
export const SyncBlockerSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_google_calendar_v1_resources_sync_blocker, 0);

/**
 * Represents something that is preventing a successful sync with external services.
 *
 * @generated from enum studyo.today.google_calendar.v1.resources.SyncBlocker
 */
export const SyncBlocker = /*@__PURE__*/
  tsEnum(SyncBlockerSchema);

